import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import DownloadState from "../DownloadState";
import {Radio, Form, Checkbox, FormControl} from 'react-bootstrap';
import {Destination} from "../../../../integration/representation/contract";
import {
    setUseProjectRef,
    SetUseProjectRef,
    setUseContractProjectRef,
    SetUseContractProjectRef,
    setCustomProjectRef,
    SetCustomProjectRef
} from "../actions";

interface TagProps {
}

interface DispatchProps {
    doSetUseProjectRef: SetUseProjectRef
    doSetUseContractProjectRef: SetUseContractProjectRef,
    doSetCustomProjectRef: SetCustomProjectRef
}

interface StateProps {
    destination: Destination;
    useProjectRef: boolean;
    useContractProjectRef: boolean;
    contractProjectRef: string;
    customProjectRef: string;
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: DownloadState): StateProps => {
    return {
        destination: selectors.destination(state),
        useProjectRef: selectors.useProjectRef(state),
        useContractProjectRef: selectors.useContractProjectRef(state),
        contractProjectRef: selectors.contractProjectRef(state),
        customProjectRef: selectors.customProjectRef(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetUseProjectRef: setUseProjectRef,
    doSetUseContractProjectRef: setUseContractProjectRef,
    doSetCustomProjectRef: setCustomProjectRef
});


class Component extends React.Component<Props, {}> {

    handleUseProjectRefChange(e: any) {
        this.props.doSetUseProjectRef(!this.props.useProjectRef);
    }

    handleUseContractProjectRefChange(e: any) {
        this.props.doSetUseContractProjectRef(!this.props.useContractProjectRef);
    }

    handleCustomProjectRefChange(event: any) {
        this.props.doSetCustomProjectRef(event.target.value);
    }

    render() {
        let { destination, useProjectRef, useContractProjectRef, contractProjectRef, customProjectRef } = this.props;

        return (
            <>
                {destination === "NVDB" &&
                    <div className={"download-selection-box"}>
                        <h2>Prosjektreferanse</h2>
                            <p>Prosjektreferansen vil overskrive eventuelle prosjektreferanser på enkeltobjekter i nedlastet fil.</p>
                            <Form>
                            <Checkbox
                            defaultChecked={useProjectRef}
                            onChange={(e) => this.handleUseProjectRefChange(e)}
                            >
                            Bruk prosjektreferanse
                            </Checkbox>
                            </Form>
                        {useProjectRef &&
                            <Form>
                                <Radio
                                    checked={useContractProjectRef}
                                    onChange={(e) => this.handleUseContractProjectRefChange(e)}>
                                    Bruk kontraktens referanse-ID som prosjektreferanse <label><b>{contractProjectRef}</b></label>
                                </Radio>
                                <Radio
                                    checked={!useContractProjectRef}
                                    onChange={(e) => this.handleUseContractProjectRefChange(e)}>
                                    Bruk annen prosjektreferanse:
                                </Radio>
                                <FormControl
                                    type="text"
                                    placeholder="Referanse-ID"
                                    defaultValue={customProjectRef}
                                    disabled={!useProjectRef || useContractProjectRef}
                                    onChange={this.handleCustomProjectRefChange.bind(this)} />
                            </Form>
                        }
                    </div>
                }
            </>
        )
    }
}

export const ProjectRefSelection = connect(mapStateToProps, mapDispatchToProps)(Component);
